export const iconFontAwesomeHumanitarianArrowUpRightFromSquare = (
	<i className="fa-solid fa-arrow-up-right-from-square"></i>
);
